<script setup lang="ts">
import { effectiveUI } from '@/i18n'
</script>

<template>
  <section class="faq-section">
    <h2 class="faq-title">{{ effectiveUI.faqTitle }}</h2>
    <div class="faq-list">
      <details v-for="(item, index) in effectiveUI.faqItems" :key="index" class="faq-item">
        <summary class="faq-question">{{ item.question }}</summary>
        <p class="faq-answer">{{ item.answer }}</p>
      </details>
    </div>
  </section>
</template>

<style scoped>
.faq-section {
  margin-top: 3rem;
  margin-bottom: 2rem;
}

.faq-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 1.5rem 0;
  text-align: center;
}

.faq-list {
  max-width: 768px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.faq-item {
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  overflow: hidden;
  transition: border-color var(--transition-normal);
}

.faq-item[open] {
  border-color: var(--primary-color);
}

.faq-question {
  padding: 1rem 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  user-select: none;
  transition: background-color var(--transition-normal);
}

.faq-question::-webkit-details-marker {
  display: none;
}

.faq-question::after {
  content: '+';
  font-size: 1.25rem;
  font-weight: 400;
  color: var(--text-secondary);
  flex-shrink: 0;
  transition: transform var(--transition-normal);
}

.faq-item[open] .faq-question::after {
  content: '\2212';
}

.faq-question:hover {
  background: var(--hover-tint);
}

.faq-answer {
  padding: 0 1.25rem 1rem;
  margin: 0;
  color: var(--text-secondary);
  line-height: 1.7;
  font-size: 0.9375rem;
}

@media (max-width: 640px) {
  .faq-title {
    font-size: 1.25rem;
  }

  .faq-question {
    padding: 0.875rem 1rem;
    font-size: 0.9375rem;
  }

  .faq-answer {
    padding: 0 1rem 0.875rem;
    font-size: 0.875rem;
  }
}
</style>
